<template>
  <div class="tag-container">
    <div class="tag tag-new" v-if="product.is_new"></div>
    <div class="tag-hot-container" v-if="peppersCount > 0">
      <div
        v-for="index in peppersCount"
        :key="index"
        class="tag tag-hot tag-hot-pepper"
        :style="{ left: peppersLeftPosition(index) + `rem` }"
      ></div>
    </div>
    <div class="tag tag-only-pickup" v-if="product.only_pickup">
      <div class="pp-icon pp-icon-basket-circle-pickup"></div>
    </div>
    <div class="tag tag-share" v-if="product.share_id > 0" @click="openShareModal(product.share_id)"></div>
  </div>
</template>

<script>
import ProductCard from "@/components/catalog/ProductCard.vue";

export default {
  name: "Tags",
  props:['product'],
  mixins: [ProductCard],
  methods: {
    peppersLeftPosition(index) {
      switch (index){
        case 1:
          return 0.75;
        case 2:
          return -0.125;
        case 3:
          return -1;
      }
    },
  },
  computed: {
    peppersCount() {
      const strongLevel = Number(this.product.is_strong);

      if (!Number.isNaN(strongLevel) && strongLevel > 0) {
        return Math.min(strongLevel, 3);
      }

      return this.product.is_strong ? 1 : 0;
    }
  },
  mounted() {}
}
</script>

<style scoped>
.tag-hot-container {
  position: relative;
  display: flex;
  min-width: 2.5rem;
  height: 2.5rem;
}

.tag-hot-pepper {
  position: absolute;
  rotate: 130deg;
  transform: scaleY(-1);
}

</style>
